import * as React from 'react';
import classNames from 'classnames';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';

const styles = require('./styles.pcss');

type Props = {
  rowColumns: Array<any>;
  showRemove?: boolean;
  clickRemove?: any;
};

const HotelTableRow = (props: Props) => {
  const tableColumn = (name: string, i: number) => (
    <TableCell
      key={i}
      className={classNames(styles.tableCell)}
    >
      {name}
    </TableCell>
  );

  const displayRemove = (props: Props) => {
    if (props.showRemove) {
      return (
        <TableCell
          key={'rem'}
          className={classNames(styles.tableCell, styles.removeCell)}
        >
          <Button
            color="primary"
            onClick={props.clickRemove}
          >
            Remove
          </Button>
        </TableCell>
      );
    }
    return (
      <TableCell
        key={'rem'}
        className={classNames(styles.tableCell)}
      ></TableCell>
    );
  };

  return (
    <TableRow className={classNames(styles.tableRow)}>
      {props.rowColumns.map(tableColumn)}
      {displayRemove(props)}
    </TableRow>
  );
};

export default HotelTableRow;
